export default __webpack_public_path__ + "static/media/DanielGonzalez1.c4190849.png";